// extracted by mini-css-extract-plugin
module.exports = {"tileWH":"9%","tileContainerWH":"12%","tileContainerLengthMobile":"16%","container":"DisplayScore_container__3I99P"};